import { StateType } from '../state_type.enum'

export const typeToPathMap = {
  [StateType.Map]: 'map',
  [StateType.Lobby]: 'lobby',
  [StateType.Game]: 'game',
  [StateType.Replay]: 'replay',
} as const
